module.exports = __webpack_public_path__ + "media/images/flags/4x3/bgr-1cfb5ee22272da2036216fec3f6ec83d.svg";